<template>
	<div id='depreciationSummary'>
		<div class="public-content">
			<div class="form-item-public">
				<el-form inline>
					<el-form-item label="折旧明细表">
					    <el-date-picker
						type="month"
						size="mini"
						placeholder="选择月"
						v-model='date.start'
						:picker-options = 'pickerBeginDateBefore'
						@change="dateChange($event, 'start')"
						format="yyyy 年 MM 月" style='width: 140px;'>
					    </el-date-picker>
					    <span>至</span>
					    <el-date-picker
						type="month"
						size="mini"
						v-model='date.end'
						:picker-options='pickerBeginDateAfter'
						@change="dateChange($event, 'end')"
						placeholder="选择月"
						format="yyyy 年 MM 月" style='width: 140px;'>
					    </el-date-picker>
				    </el-form-item>
				    <el-form-item>
				    	<el-button size='mini' class='minButton' @click='setTableConfig'>搜索</el-button>
				    </el-form-item>
					<div class="fr">
						<el-button size='mini' v-for='item in buttons'  :key='item.id' @click="handleButtonOperation(item.function)" class='minButton'>
								{{item.name}}
						</el-button>
					</div>

				</el-form>

			</div>
			<!-- 表格 -->
			<public-table :table='tableData'></public-table>
		</div>
	</div>
</template>
<script>
	import {currencys} from '@/assets/utils/currencyFormat'
	import publicTable from '@/components/publicTable'
	export default {
		components: {
			publicTable
		},
		data() {
			return {
				isFirstActive: false,
				pickerBeginDateBefore: {
					disabledDate: (time)=>{
						 let startVal = this.getAccountPeriod.startTimeStamp;
						 let endVal = this.getAccountPeriod.endTimeStamp;
						 if(startVal && endVal) {
						 	return time.getTime() < startVal || time.getTime() > endVal
						 }
					}
				},
				pickerBeginDateAfter: {
					disabledDate: (time)=>{
						let startYear = new Date(this.date.start);
						let endYear = startYear ? new Date(startYear.getFullYear()+1, 0) : ''
						let startVal = this.getAccountPeriod.startTimeStamp;
						let endVal = this.getAccountPeriod.endTimeStamp;
						if(startYear) {

							return time.getTime() < startYear || time.getTime() >=endYear || time.getTime() > endVal
						}else{
							if(startVal && endVal) {
							 	return time.getTime() < startVal || time.getTime() > endVal
							 }
						}
					}
				},
				config: [{
					label: '类别',
					value: 'genresName',
					show: 'normal',
					width: 160,
					fixed: true
				},{
					label: '编码',
					value: 'assetsCode',
					show: 'normal',
					fixed: true
				},{
					label: '名称',
					value: 'assetsName',
					show: 'normal',
					fixed: true
				},{
					label: '原值',
					value: 'resourceAssets',
					show: 'normal',
					width: 140,
					formatter: this.formatter
				},{
					label: '本期折旧',
					value: 'monthdepreciation',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '期末累计折旧',
					value: 'endDepreciation',
					width: 180,
					show: 'normal',
					formatter: this.formatter
				},{
					label: '减值准备',
					value: 'depreciationReserves',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '期末净值',
					value: 'endNetvalue',
					width: 120,
					show: 'normal',
					formatter: this.formatter
				}],
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					key: 0,						// 渲染Table
					config: this.config,
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
					getSummaries: this.getSummaries,			// 自定义合计方法
					arraySpanMethod: this.arraySpanMethod,		// 自定义合并行
				},
				buttons:[],
				date: {
					start:'',           // 当前选择开始日期
					end: '',			// 当前选择结束日期
				},
				form: {							// 筛选条件
					startperiods: '',			// 开始周期（月）
					endperiods: '',				// 结束周期（月）
					type: 'detail',				// 折旧明细
					selectYear: ''				// 当前年
				},
			}

		},
		created() {
			this.tableData.config = this.config;
			this.getAccountPeriods();
			let params=['ac:asseDetail:export'];
			this.setButtons(params,'buttons');

		},
		computed: {
			getAccountPeriod() {
				return this.$store.state.accountInfo.yearPeriods;
			},
			getClickCache() {
				return this.$store.state.loadstatus.isClickCache;
			},
		},
		activated() {
			if(this.getClickCache && this.isFirstActive) {
				this.getDepreciationsum();
			}
			this.isFirstActive = true;
		},
		methods: {
			// 选择会计期间
			dateChange (val, name) {
				if (name == 'start') {
					this.form = Object.assign({}, this.form, {
						startperiods: this.$util.formatDate.format(val, 'MM'),
						endperiods: this.$util.formatDate.format(val, 'MM')
					})
					this.date = Object.assign(this.date, {
						start: val,
						end: val
					})
				} else {
					this.$set(this.form, 'endperiods', this.$util.formatDate.format(val, 'MM'));
				}
				this.form.selectYear = this.$util.formatDate.format(val, 'yyyy');
			},

			// 给按钮设置值
			setButtons(arr,key){
				let params={
					permissions:arr.join(',')
				}
				try {
					this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
						if(res && res.data.code == 1) {
							if(res.data.data.length){
								this[key] = res.data.data;
							}
						}
					})
				}catch(e){
				}
			},

			handleButtonOperation(name){
					const params = {
						cid: sessionStorage.cid,
						token: sessionStorage.token,
						type:'detail',
						startperiods: this.form.startperiods,
						endperiods: this.form.endperiods,
						selectYear: this.form.selectYear

					}
					console.log(params)
					const router =this.$router.resolve({
						path: 'auxiliary/fixedAssetAsseDetail',
						query: params
					})
					location.href = this.$rootUrl + router.href

			},

			// 格式化数据
			formatter (row, column) {
				// 计算小计行中所有类别相同的和

				if (row.assetsName == '小计') {
					const values = this.tableData.data.map(item => {
						if (item.assetsName != '小计') {
							if (row.genresName == item.genresName) {
								return Number(item[column.property]);
							}
						}
					})

					if (!values.every(value => {isNaN(value)})) {
						return values.reduce((prev, curr) => {
							const value = Number(curr);
							if(!isNaN(value)) {
								return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
							} else {
								return parseFloat(prev).toFixed(2);
							}
						}, 0);
					} else {
						return '';
					}
				} else {
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
				}
			},
			// 自定义合计
			getSummaries (param) {
				const { columns, data } = param;
				const sums = [];

				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					if(index === 1 || index === 2) {
						return;
					}
					const values = data.map(item => {
						return Number(item[column.property])
					});

					if (!values.every(value => {isNaN(value)})) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if(!isNaN(value)) {
								prev = Number(prev)
								if(!(parseFloat(prev)+parseFloat(curr))) {
									return '';
								}else {
									return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
								}
							} else {
								return parseFloat(prev).toFixed(2);
							}
						}, 0);
					} else {
						sums[index] = '';
					}
				});
				if(sums) {
					return sums;
				}else {
					return '';
				}
			},
			// 自定义合并行
			arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
				if (columnIndex === 0) {
					if (row.rows) {
						return {
							rowspan: row.rows,
							colspan: 1
						}
					} else {
						return {
							rowspan: 0,
							colspan: 0
						}
					}
				}
			},
			// 计算期末累计折旧(会计期间所选月数总和)
			getSumDepreciation () {
				let data = this.tableData.config.map(item => {
					if (item.type == 'month') {
						return item.value;
					}
				}).filter(item => item);
				let sums = []

				this.tableData.data.forEach((column, index) => {
					const values = data.map(item => Number(column[item]));

					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
							} else {
								return parseFloat(prev).toFixed(2);
							}
						}, 0);
					} else {
						sums[index] = '';
					}
					column.currentEndDepreciation = sums[index];
				})
			},
			// 设置表头
			setTableConfig () {
        const fullYear = new Date(this.date.start).getFullYear();
				let data = {
					month: [ fullYear+ '1期', '2期', '3期', '4期', '5期', '6期', '7期', '8期', '9期', '10期', '11期', '12期'],
					value: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'december']
				}
        //data.month = data.month.map(i=> (fullYear + i))
				let defaultConfig = [];
				let monthConfig = [];
				let startConfig = [];
				let endConfig = [];
				let mergeConfig = [];
				let startMonth = Number(this.form.startperiods.replace(/^0+/, ''));
				let endMonth = Number(this.form.endperiods.replace(/^0+/, ''));
				if (this.form.startperiods && this.form.endperiods) {
					this.$set(this.tableData, 'config', this.config);

					// 如果开始时间等于结束时间
					if (this.form.startperiods == this.form.endperiods) {
						monthConfig.push({
							label: data.month[startMonth-1],
							value: data.value[startMonth-1],
							show: 'normal',
							type: 'month',
							formatter: this.formatter
						})
					}
					// 如果开始时间小于结束时间
					if (this.form.startperiods < this.form.endperiods) {
						for (let i = startMonth-1; i < endMonth; i++) {
							monthConfig.push({
								label: data.month[i],
								value: data.value[i],
								show: 'normal',
								type: 'month',
								formatter: this.formatter
							})
						}
					}
					if (monthConfig.length) {

						defaultConfig = this.tableData.config.filter((item, index) => {
							return item.value != 'monthdepreciation' && item.value != 'endDepreciation'
						})

						startConfig = defaultConfig.slice(0, 4);
						endConfig = defaultConfig.slice(4);

						this.tableData.config = mergeConfig.concat(startConfig, monthConfig, endConfig).map(item => {
								if (item.value == 'currentEndDepreciation') {
									item.label = `${this.form.selectYear}年${this.form.startperiods}-${this.form.endperiods}期期末累计折旧`;
									item.show = 'normal';
								}
								return item;
						});
					}
				} else {
					this.$notify.error('请选择正确的期间!');
					return;
				}

				this.getDepreciationsum();
			},
			// 获取会计期间/初始化数据
			getAccountPeriods() {
				let accountInfo = this.$getSessionStorage('accountInfo')
				if(!this.getAccountPeriod) {
					this.$store.dispatch('getAllYearPeriodsData')
				}
				this.date = Object.assign(this.date,{
					start: accountInfo.yearPeriodTimeStamp,
					end: accountInfo.yearPeriodTimeStamp,
				})

				this.form = Object.assign(this.form , {
					startperiods: this.$util.formatDate.format(this.date.start , 'MM'),
					endperiods: this.$util.formatDate.format(this.date.end , 'MM'),
					selectYear: this.$util.formatDate.format(this.date.start , 'yyyy'),
				})
				// this.getDepreciationsum();
        this.setTableConfig();
			},
			// 获取折旧明细表格数据
			getDepreciationsum() {
				try {
					this.tableData.loading = true;
					this.$http.post('assets/findDetail',this.form).then(res=>{
						this.tableData.loading = false;
						if(res && res.data.code) {
							let num = 0, arr = [], name;
							this.tableData.data = res.data.data.map((item, index) => {
								for (const i in item) {
									if (typeof item[i] === 'number') {
										item[i] = item[i] == 0 ? '' : item[i];
									}
								}
								// 根据相同类别设置rowspan合并行数
								name = res.data.data[num].genresName
								if (item.genresName == name) {
									arr = arr.concat(item);
									res.data.data[num].rows = arr.length
								} else {
									num = index;
									arr = [];
									arr = arr.concat(item);
									res.data.data[num].rows = arr.length;
								}
								return item;
							})
							if (this.tableData.data.length) {
								this.tableData.hasShowSummary = true;
							}
							this.getSumDepreciation();
						}

					})
				}catch(e){

				}finally {
					this.tableData.loading = false;
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/assets/depreciationDetails.vue